import { useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { signinRedirect } = useAuth();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  // 🔥 Prevent Safari / S3 / CloudFront / Chrome BFCache behavior
  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.onpageshow = (evt) => {
      if (evt.persisted) {
        window.location.reload();
      }
    };
  }, []);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const intent = localStorage.getItem("login_intent");

    if (intent === "from_header") {
      localStorage.removeItem("login_intent");
      signinRedirect();
      return;
    }

    navigate("/", { replace: true });
  }, [navigate, signinRedirect]);

  return (
    <Backdrop open sx={{ color: "#fff", zIndex: 9999 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Login;
